<template>
  <div>
    <h1 class="page-header">{{ $t('logicalPosition.pageTitle') }}</h1>
    <div>
      <ts-card>
        <ts-card-wrapper>
          <div class="d-flex justify-content-between">
            <ts-button color="info" outline @click="showForm()">{{ $t('addNew') }}</ts-button>
            <ts-input v-model="search" :placeholder="$t('search')" style="width: 300px;" />
          </div>
        </ts-card-wrapper>
        <ts-table :columns="columns" :records="resources" :loading="loading">
          <template v-slot="{ record }">
            <td>{{ record.position_name_kh }}</td>
            <td>{{ record.position_name_en }}</td>
            <td>{{ record.position_level ? record.position_level.position_level_name_en : '' }}</td>
            <td>{{ record.job_title ? record.job_title.job_title_en : '' }}</td>
            <td>{{ record.report_to_position ? record.report_to_position.position_name_en : '' }}</td>
            <td>{{ record.org_chart_structure ? record.org_chart_structure.org_chart_structure : '' }}</td>
            <td class="ts-text-center">
              <i class="fas fa-check ts-text-green-500" v-show="record.is_head"></i>
              <i class="fas fa-times ts-text-red-500" v-show="!record.is_head"></i>
            </td>
            <td class="ts-text-center">
              <i class="fas fa-check ts-text-green-500" v-show="record.is_allow_ot_claim"></i>
              <i class="fas fa-times ts-text-red-500" v-show="!record.is_allow_ot_claim"></i>
            </td>
            <td class="text-center">
              <a href="#" v-tooltip="'Edit'" class="text-primary mr-2" @click.prevent="edit(record)">
                <i class="fas fa-edit"></i>
              </a>
              <a
                href="#"
                v-tooltip="'Delete'"
                class="text-danger"
                @click.prevent="destroy(record)"
                :disabled="record._deleting"
              >
                <i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
                <i class="fas fa-trash" v-else></i>
              </a>
            </td>
          </template>
        </ts-table>
        <div class="d-flex justify-content-end p-15">
          <ts-pagination v-model="pagination" @navigate="fetchData"></ts-pagination>
        </div>
      </ts-card>
    </div>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import FormComponent from './form.vue'

export default {
  name: 'logical-position',
  components: { FormComponent },
  data() {
    return {
      loading: false
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('hr/logicalPosition', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.hr.logicalPosition.search
      },
      set(newValue) {
        this.$store.commit('hr/logicalPosition/SET_SEARCH', newValue)
        this.$store.commit('hr/logicalPosition/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        {
          name: this.$t('logicalPosition.positionNameKh'),
          sortKey: 'position_name_kh'
        },
        {
          name: this.$t('logicalPosition.positionNameEn'),
          sortKey: 'position_name_en'
        },
        {
          name: this.$t('logicalPosition.positionLevel'),
          sortKey: 'position_level.position_level_name_en'
        },
        {
          name: this.$t('logicalPosition.jobTitle'),
          sortKey: 'job_title.job_title_en'
        },
        {
          name: this.$t('logicalPosition.reportToPosition'),
          sortKey: 'report_to_position.position_level_name_en'
        },
        {
          name: this.$t('logicalPosition.orgChartStructure'),
          sortKey: 'org_chart_structure.org_chart_structure'
        },
        {
          name: this.$t('logicalPosition.isHead'),
          style: 'text-align:center'
        },
        {
          name: this.$t('logicalPosition.allowOT'),
          style: 'text-align:center'
        },
        { name: this.$t('actions'), style: 'text-align:center; width: 1px;' }
      ]
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('hr/logicalPosition/fetch', {
          ...attributes,
          include: 'position_level,job_title,report_to_position,org_chart_structure'
        })
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    edit(record) {
      this.showForm(record)
    },
    async destroy(record) {
      if (await this.$confirmModal.danger('Are you sure to delete ?')) {
        record._deleting = true
        this.$store
          .dispatch('hr/logicalPosition/destroy', record.position_id)
          .then(response => {
            this.fetchData()
            this.$toasted.success(response.message)
            record._deleting = false
          })
          .catch(error => {
            this.$toasted.error(error.message)
            record._deleting = false
          })
      }
    },
    showForm(editData) {
      this.$modal.show(
        FormComponent,
        {
          editData: editData
        },
        {
          height: 'auto',
          width: '400px',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        }
      )
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('hr/logicalPosition/RESET_STATE')
    next()
  }
}
</script>
